/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface TenureStatsSchema {
  avg_months?: number | null;
  p25_months?: number | null;
  median_months?: number | null;
  p75_months?: number | null;
}
